module.exports = __webpack_public_path__ + "img/nature-66.04d7f2a8.jpg";